import { Component, OnInit, ViewChild, HostListener, ElementRef } from "@angular/core";
import { Constant } from "../core/constant";
import { AdminService } from "../services/admin.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { MatMenuTrigger } from "@angular/material/menu";
import { Router } from "@angular/router";
import { CategoryList } from "../models/category-list";
import { Category } from "../models/category";
import { CustomEventNRService } from "../services/custom-event-nr.service";
import { SnackbarService } from "../services/snackbar.service";

@Component({
  selector: "app-view-all-category-list",
  templateUrl: "./view-all-category-list.component.html",
  styleUrls: ["./view-all-category-list.component.scss"],
})
export class ViewAllCategoryListComponent implements OnInit {
  activePopupId: string | number | null = null;
  loading: boolean = false;
  pageSizes: any[] = Constant.PageSizes;
  searchKey: string = "";

  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;
  totalPages: number = 0;

  categoryList: CategoryList = new CategoryList();
  allCategories: Category[] = [];
  error: string = "";
  modalOption: NgbModalOptions = {};
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  @ViewChild("newCategoryInput", { static: false }) newCategoryInput: ElementRef;

  editingCategoryId: number | null = null;
  editCategoryName: string = "";
  editCategoryDescription: string = "";

  isAddingNewCategory: boolean = false;
  newCategoryName: string = "";
  newCategoryDescription: string = "";

  constructor(
    private adminService: AdminService,
    private ngbModal: NgbModal,
    private router: Router,
    private customEventNRService: CustomEventNRService,
    private snackbarService: SnackbarService,
  ) {}

  ngOnInit() {
    this.getCategoryList();
  }

  selectedItemsPerPageChange(event) {
    this.page = 1;
    this.pageSize = event.value;
    this.getCategoryList();
  }

  getCategoryList(): void {
    this.loading = true;
    this.adminService.GetCategoryList(0, 10000, "").subscribe(
      (allData: CategoryList) => {
        this.allCategories = (allData.categories || []).map((o) => new Category(o));
      },
      () => {}
    );

    this.adminService
      .GetCategoryList(
        (this.page - 1) * this.pageSize,
        this.pageSize,
        this.searchKey
      )
      .subscribe(
        (data: CategoryList) => {
          this.categoryList.categories = data.categories.map(
            (o) => new Category(o)
          );
          this.collectionSize = data.count;
          this.totalPages = Math.ceil(this.collectionSize / this.pageSize);
          if (this.searchKey) {
            this.customEventNRService.sendSearchEvent(
              "GrsSearchEvents",
              this.searchKey,
              this.collectionSize,
              window.location.href,
            );
          }
          this.loading = false;
        },
        (error: string) => {
          this.error = error;
          const modalRef = this.ngbModal.open(FailModuleComponent);
          this.error = error;
          modalRef.componentInstance.errorMessage = error;
          this.loading = false;
        }
      );
  }

  isNewCategoryNameDuplicate(): boolean {
    if (!this.newCategoryName || !this.newCategoryName.trim()) {
      return false;
    }
    const target = this.newCategoryName.trim().toLowerCase();
    return this.allCategories.some(
      (c) => c.name && c.name.trim().toLowerCase() === target
    );
  }

  isEditCategoryNameDuplicate(): boolean {
    if (!this.editCategoryName || !this.editCategoryName.trim()) {
      return false;
    }
    const target = this.editCategoryName.trim().toLowerCase();
    return this.allCategories.some(
      (c) => c.id !== this.editingCategoryId && c.name && c.name.trim().toLowerCase() === target
    );
  }

  addSearchKey(searchKey: string) {
    this.searchKey = searchKey;
    this.page = 1;
    this.getCategoryList();
  }

  togglePopup(event: Event, item: any) {
    event.stopPropagation();
    const id = item.id;
    this.activePopupId = this.activePopupId === id ? null : id;
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest(".grid-actions")) {
      this.activePopupId = null;
    }
  }

  goToPreviousPage() {
    if (this.page > 1) {
      this.page--;
      this.getCategoryList();
    }
  }

  goToNextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.getCategoryList();
    }
  }

  onAddEditCategory(categoryId: number = null) {
    if (!categoryId) {
      this.startAddNewCategory();
    } else {
      const item = this.categoryList.categories.find((c) => c.id === categoryId);
      if (item) {
        this.onEdit(item);
      }
    }
  }

  startAddNewCategory() {
    this.cancelInlineEdit();
    this.isAddingNewCategory = true;
    this.newCategoryName = "";
    this.newCategoryDescription = "";

    setTimeout(() => {
      if (this.newCategoryInput && this.newCategoryInput.nativeElement) {
        this.newCategoryInput.nativeElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        this.newCategoryInput.nativeElement.focus();
      }
    }, 100);
  }

  cancelAddNewCategory() {
    this.isAddingNewCategory = false;
    this.newCategoryName = "";
    this.newCategoryDescription = "";
  }

  saveNewCategory() {
    if (!this.newCategoryName || !this.newCategoryDescription || this.isNewCategoryNameDuplicate()) {
      return;
    }
    this.loading = true;
    const newCat = new Category();
    newCat.id = 0;
    newCat.name = this.newCategoryName.trim();
    newCat.description = this.newCategoryDescription.trim();

    this.adminService.AddCategory(newCat).subscribe(
      (res: any) => {
        this.loading = false;
        if (res === false) {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = "Name or title already taken.";
          return;
        }
        this.isAddingNewCategory = false;
        this.newCategoryName = "";
        this.newCategoryDescription = "";
        this.snackbarService.showSuccess("Category Added Successfully");
        this.getCategoryList();
      },
      (err: any) => {
        this.loading = false;
        const modalRef = this.ngbModal.open(FailModuleComponent);
        modalRef.componentInstance.errorMessage =
          typeof err === "string" ? err : "Failed to add category.";
      }
    );
  }

  onEdit(item: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.cancelAddNewCategory();
    this.activePopupId = null;
    this.editingCategoryId = item.id;
    this.editCategoryName = item.name;
    this.editCategoryDescription = item.description;
  }

  cancelInlineEdit() {
    this.editingCategoryId = null;
    this.editCategoryName = "";
    this.editCategoryDescription = "";
  }

  saveInlineCategory(item: any) {
    if (!this.editCategoryName || !this.editCategoryDescription || this.isEditCategoryNameDuplicate()) {
      return;
    }
    this.loading = true;
    const categoryToUpdate = new Category(item);
    categoryToUpdate.name = this.editCategoryName.trim();
    categoryToUpdate.description = this.editCategoryDescription.trim();

    this.adminService.UpdateCategory(categoryToUpdate).subscribe(
      (res: any) => {
        this.loading = false;
        if (res === false) {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = "Name or title already taken.";
          return;
        }
        this.editingCategoryId = null;
        this.snackbarService.showSuccess("Category Updated Successfully");
        this.getCategoryList();
      },
      (err: any) => {
        this.loading = false;
        const modalRef = this.ngbModal.open(FailModuleComponent);
        modalRef.componentInstance.errorMessage =
          typeof err === "string" ? err : "Failed to update category.";
      }
    );
  }

  actionMenuOpen(event: Event) {
    event.stopPropagation();
  }

  closeMatMenuAndOpenDeleteModal(item, event) {
    if (this.trigger) {
      this.trigger.closeMenu();
    }
    setTimeout(() => {
      this.openDeleteModal(item, event);
    }, 100);
  }

  openDeleteModal(item, event) {
    event.stopPropagation();
    this.activePopupId = null;
    const modalRef = this.ngbModal.open(DeleteDialogComponent);
    modalRef.componentInstance.title =
      "Do you want to remove this Category from the list? ";
    modalRef.componentInstance.deleteItem = item;
    modalRef.componentInstance.message =
      "All the dependencies will be removed along with this Category";
    if (this.trigger) {
      this.trigger.closeMenu();
    }
    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItem) => {
      if (deleteItem != null) {
        let category = new Category(item);
        this.loading = true;
        this.adminService.DeleteCategory(category).subscribe((data: any) => {
          this.loading = false;
          this.page = 1;
          this.getCategoryList();
        });
      }
      this.ngbModal.dismissAll();
    });
  }
}

